<div data-main-container>
  <ng-content></ng-content>
</div>
